import { AuditLogGetData } from '~/api/def/endpoints/auditLogEndpoint';

export const generateAction = (changes: AuditLogGetData['changes']): string => {
  const keys = Object.keys(changes);
  if (keys.length === 0) return 'Uncategorized change';

  const actionMap: { [key: string]: string } = {
    id: 'ID',
    uuid: 'UUID',
    name: 'name',
    logo: 'logo',
    incorporationDate: 'incorporation date',
    deletedAt: 'deletion status',
    createdBy: 'creator',
    currentRound: 'current round',
    companyStatus: 'company status',
    createdAt: 'creation date',
    updatedAt: 'modification date',
    fundId: 'fund ID',
    sectorId: 'sector',
    companyId: 'company ID',
    closeDate: 'close date',
    shortName: 'short name',
    groupId: 'group ID',
  };

  const items = keys.map((key) => actionMap[key] || key);

  if (items.length === 1) return `Updated ${items[0]}`;

  if (items.length === 2) return `Updated ${items[0]} and ${items[1]}`;

  const lastItem = items.pop();

  return `Updated ${items.join(', ')}, and ${lastItem}`;
};
